import { useState } from 'react';
import {
  Avatar, Button, TextField, Typography,
  Paper, Snackbar, IconButton,
} from '@mui/material';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import CloseIcon from '@mui/icons-material/Close';
import axios from '../../../services/api';
import Spinner from '../../Spinner/Spinner';

export default function Contact({ class_id }) {
  const [name, setName] = useState('');
  const [mail, setMail] = useState('');
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [snack, setSnack] = useState({ open: false, msg: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name) { setSnack({ open: true, msg: 'Morate unijeti ime!' }); return; }
    if (!mail) { setSnack({ open: true, msg: 'Morate unijeti mail adresu!' }); return; }
    if (!content) { setSnack({ open: true, msg: 'Morate unijeti sadržaj!' }); return; }

    setLoading(true);
    axios.post('/api/sendmail', { name, mail, content, class_id })
      .then((response) => {
        setLoading(false);
        if (response && response.data) {
          setSnack({ open: true, msg: 'Došlo je do greške prilikom slanja mail-a!' });
        } else {
          setName(''); setMail(''); setContent('');
          setSnack({ open: true, msg: 'Mail je uspješno poslat!' });
        }
      })
      .catch(() => {
        setLoading(false);
        setSnack({ open: true, msg: 'Došlo je do greške prilikom slanja mail-a!' });
      });
  };

  return (
    <div>
      {loading && <Spinner />}
      <Paper elevation={6} square sx={{ maxWidth: 600, margin: '0 auto' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 32 }}>
          <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
            <MailOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Pošaljite mail odjeljenskom starješini
          </Typography>
        </div>
        <div style={{ padding: 20 }}>
          <form onSubmit={handleSubmit}>
            <TextField variant="outlined" margin="normal" fullWidth label="Vaše ime" name="name"
              autoFocus onChange={(e) => setName(e.target.value)} value={name} />
            <TextField variant="outlined" margin="normal" fullWidth label="Vaša mail adresa" name="mail"
              onChange={(e) => setMail(e.target.value)} value={mail} />
            <TextField variant="outlined" multiline rows={5} margin="normal" fullWidth label="Sadržaj" name="content"
              onChange={(e) => setContent(e.target.value)} value={content} />
            <Button type="submit" fullWidth variant="contained" color="primary" sx={{ mt: 3, mb: 2 }}>
              Pošalji
            </Button>
          </form>
        </div>
      </Paper>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={snack.open} autoHideDuration={4000}
        onClose={() => setSnack({ ...snack, open: false })}
        message={snack.msg}
        action={
          <IconButton size="small" color="inherit" onClick={() => setSnack({ ...snack, open: false })}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    </div>
  );
}
